export const OVERLAY_LAYERS = [
  {
    id: 'school_districts',
    label: 'School Districts',
    color: '#e07020',
    url: 'https://services1.arcgis.com/Ua5sjt3LWTPigjyD/arcgis/rest/services/School_Districts_Current/FeatureServer/0/query',
    stateField: 'STATEFP',
    labelField: 'NAME',
  },
  {
    id: 'congress_districts',
    label: 'Congressional Districts',
    color: '#6030c0',
    url: 'https://services2.arcgis.com/FiaPA4ga0iQKduv3/arcgis/rest/services/Congressional_Districts_v1/FeatureServer/0/query',
    stateField: 'STATE',
    labelField: 'NAME',
  },
];
